import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const IranFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14993'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14993)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#38BB56'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#DE1B27'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M1.28646 3.73328C1.10236 3.73328 0.953125 3.88251 0.953125 4.06661V4.33328C0.953125 4.51737 1.10236 4.66661 1.28646 4.66661H1.57217C1.75627 4.66661 1.90551 4.51737 1.90551 4.33328V4.06661C1.90551 3.88251 1.75627 3.73328 1.57217 3.73328H1.28646ZM3.19122 3.73328C3.00713 3.73328 2.85789 3.88251 2.85789 4.06661V4.33328C2.85789 4.51737 3.00713 4.66661 3.19122 4.66661H3.47693C3.66103 4.66661 3.81027 4.51737 3.81027 4.33328V4.06661C3.81027 3.88251 3.66103 3.73328 3.47693 3.73328H3.19122ZM4.76265 4.06661C4.76265 3.88251 4.91189 3.73328 5.09598 3.73328H5.3817C5.56579 3.73328 5.71503 3.88251 5.71503 4.06661V4.33328C5.71503 4.51737 5.56579 4.66661 5.3817 4.66661H5.09598C4.91189 4.66661 4.76265 4.51737 4.76265 4.33328V4.06661ZM7.00074 3.73328C6.81665 3.73328 6.66741 3.88251 6.66741 4.06661V4.33328C6.66741 4.51737 6.81665 4.66661 7.00074 4.66661H7.28646C7.47055 4.66661 7.61979 4.51737 7.61979 4.33328V4.06661C7.61979 3.88251 7.47055 3.73328 7.28646 3.73328H7.00074ZM8.57217 4.06661C8.57217 3.88251 8.72141 3.73328 8.90551 3.73328H9.19122C9.37532 3.73328 9.52455 3.88251 9.52455 4.06661V4.33328C9.52455 4.51737 9.37532 4.66661 9.19122 4.66661H8.90551C8.72141 4.66661 8.57217 4.51737 8.57217 4.33328V4.06661ZM10.8103 3.73328C10.6262 3.73328 10.4769 3.88251 10.4769 4.06661V4.33328C10.4769 4.51737 10.6262 4.66661 10.8103 4.66661H11.096C11.2801 4.66661 11.4293 4.51737 11.4293 4.33328V4.06661C11.4293 3.88251 11.2801 3.73328 11.096 3.73328H10.8103ZM12.3817 4.06661C12.3817 3.88251 12.5309 3.73328 12.715 3.73328H13.0007C13.1848 3.73328 13.3341 3.88251 13.3341 4.06661V4.33328C13.3341 4.51737 13.1848 4.66661 13.0007 4.66661H12.715C12.5309 4.66661 12.3817 4.51737 12.3817 4.33328V4.06661ZM14.6198 3.73328C14.4357 3.73328 14.2865 3.88251 14.2865 4.06661V4.33328C14.2865 4.51737 14.4357 4.66661 14.6198 4.66661H14.9055C15.0896 4.66661 15.2388 4.51737 15.2388 4.33328V4.06661C15.2388 3.88251 15.0896 3.73328 14.9055 3.73328H14.6198ZM16.1912 4.06661C16.1912 3.88251 16.3405 3.73328 16.5246 3.73328H16.8103C16.9944 3.73328 17.1436 3.88251 17.1436 4.06661V4.33328C17.1436 4.51737 16.9944 4.66661 16.8103 4.66661H16.5246C16.3405 4.66661 16.1912 4.51737 16.1912 4.33328V4.06661ZM18.4293 3.73328C18.2452 3.73328 18.096 3.88251 18.096 4.06661V4.33328C18.096 4.51737 18.2452 4.66661 18.4293 4.66661H18.715C18.8991 4.66661 19.0484 4.51737 19.0484 4.33328V4.06661C19.0484 3.88251 18.8991 3.73328 18.715 3.73328H18.4293ZM0.953125 9.66661C0.953125 9.48251 1.10236 9.33328 1.28646 9.33328H1.57217C1.75627 9.33328 1.90551 9.48252 1.90551 9.66661V9.93328C1.90551 10.1174 1.75627 10.2666 1.57217 10.2666H1.28646C1.10236 10.2666 0.953125 10.1174 0.953125 9.93328V9.66661ZM3.19122 9.33328C3.00713 9.33328 2.85789 9.48251 2.85789 9.66661V9.93328C2.85789 10.1174 3.00713 10.2666 3.19122 10.2666H3.47693C3.66103 10.2666 3.81027 10.1174 3.81027 9.93328V9.66661C3.81027 9.48252 3.66103 9.33328 3.47693 9.33328H3.19122ZM4.76265 9.66661C4.76265 9.48251 4.91189 9.33328 5.09598 9.33328H5.3817C5.56579 9.33328 5.71503 9.48252 5.71503 9.66661V9.93328C5.71503 10.1174 5.56579 10.2666 5.3817 10.2666H5.09598C4.91189 10.2666 4.76265 10.1174 4.76265 9.93328V9.66661ZM7.00074 9.33328C6.81665 9.33328 6.66741 9.48251 6.66741 9.66661V9.93328C6.66741 10.1174 6.81665 10.2666 7.00074 10.2666H7.28646C7.47055 10.2666 7.61979 10.1174 7.61979 9.93328V9.66661C7.61979 9.48252 7.47055 9.33328 7.28646 9.33328H7.00074ZM8.57217 9.66661C8.57217 9.48251 8.72141 9.33328 8.90551 9.33328H9.19122C9.37532 9.33328 9.52455 9.48252 9.52455 9.66661V9.93328C9.52455 10.1174 9.37532 10.2666 9.19122 10.2666H8.90551C8.72141 10.2666 8.57217 10.1174 8.57217 9.93328V9.66661ZM10.8103 9.33328C10.6262 9.33328 10.4769 9.48251 10.4769 9.66661V9.93328C10.4769 10.1174 10.6262 10.2666 10.8103 10.2666H11.096C11.2801 10.2666 11.4293 10.1174 11.4293 9.93328V9.66661C11.4293 9.48252 11.2801 9.33328 11.096 9.33328H10.8103ZM12.3817 9.66661C12.3817 9.48251 12.5309 9.33328 12.715 9.33328H13.0007C13.1848 9.33328 13.3341 9.48252 13.3341 9.66661V9.93328C13.3341 10.1174 13.1848 10.2666 13.0007 10.2666H12.715C12.5309 10.2666 12.3817 10.1174 12.3817 9.93328V9.66661ZM14.6198 9.33328C14.4357 9.33328 14.2865 9.48251 14.2865 9.66661V9.93328C14.2865 10.1174 14.4357 10.2666 14.6198 10.2666H14.9055C15.0896 10.2666 15.2388 10.1174 15.2388 9.93328V9.66661C15.2388 9.48252 15.0896 9.33328 14.9055 9.33328H14.6198ZM16.1912 9.66661C16.1912 9.48251 16.3405 9.33328 16.5246 9.33328H16.8103C16.9944 9.33328 17.1436 9.48252 17.1436 9.66661V9.93328C17.1436 10.1174 16.9944 10.2666 16.8103 10.2666H16.5246C16.3405 10.2666 16.1912 10.1174 16.1912 9.93328V9.66661ZM18.4293 9.33328C18.2452 9.33328 18.096 9.48251 18.096 9.66661V9.93328C18.096 10.1174 18.2452 10.2666 18.4293 10.2666H18.715C18.8991 10.2666 19.0484 10.1174 19.0484 9.93328V9.66661C19.0484 9.48252 18.8991 9.33328 18.715 9.33328H18.4293Z'
					fill='white'
					fillOpacity='0.5'
				/>
				<mask
					id='path-6-inside-1_2332_14993'
					fill='white'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.03906 5.96484C8.75226 6.2209 8.57227 6.58987 8.57227 7.00004C8.57227 7.77324 9.21186 8.40004 10.0008 8.40004C10.7898 8.40004 11.4294 7.77324 11.4294 7.00004C11.4294 6.59761 11.2561 6.23484 10.9787 5.97946'
					/>
				</mask>
				<path
					d='M8.59506 5.46754C8.17443 5.84308 7.9056 6.3897 7.9056 7.00004H9.23893C9.23893 6.79005 9.33009 6.59872 9.48305 6.46215L8.59506 5.46754ZM7.9056 7.00004C7.9056 8.15407 8.85643 9.06671 10.0008 9.06671V7.73338C9.56729 7.73338 9.23893 7.39242 9.23893 7.00004H7.9056ZM10.0008 9.06671C11.1452 9.06671 12.0961 8.15407 12.0961 7.00004H10.7627C10.7627 7.39242 10.4344 7.73338 10.0008 7.73338V9.06671ZM12.0961 7.00004C12.0961 6.40131 11.8373 5.86371 11.4303 5.48899L10.5272 6.46994C10.675 6.60597 10.7627 6.79392 10.7627 7.00004H12.0961Z'
					fill='#D80915'
					mask='url(#path-6-inside-1_2332_14993)'
				/>
				<rect
					x='9.52344'
					y='6.53333'
					width='0.952381'
					height='1.86667'
					rx='0.476191'
					fill='#D80915'
				/>
			</g>
		</svg>
	);
};

export default IranFlagIcon;
